import api from '@/modules/api.service';
import { ReadDefensorResponseDto } from '@/api.types';

/**
 * Defensor vinculado à pessoa do usuário (ex.: login por usuário/senha sem CPF no token).
 */
export async function buscarDefensorPorPessoaIdUseCase(pessoaId: string): Promise<ReadDefensorResponseDto | null> {
  if (!pessoaId?.trim()) return null;
  try {
    const response = await api.get<ReadDefensorResponseDto>(`/defensor/by-pessoa-id/${encodeURIComponent(pessoaId.trim())}`);
    return response.data || null;
  } catch (error) {
    console.error('Erro ao buscar defensor por pessoaId:', error);
    return null;
  }
}
